module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-aai-student-image-a74545c087beb7ea4300c3f124426412.jpg";